import { render, staticRenderFns } from "./board-card.vue?vue&type=template&id=383c2d15&scoped=true&"
import script from "./board-card.vue?vue&type=script&lang=js&"
export * from "./board-card.vue?vue&type=script&lang=js&"
import style0 from "./board-card.vue?vue&type=style&index=0&id=383c2d15&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c2d15",
  null
  
)

export default component.exports